// extracted by mini-css-extract-plugin
export default {"amChart":"adWiab7J4_OhH_rFKgmC"};